import styled, { css } from "styled-components";

import { GeometrySelectionWrapper, CollapsableContainer } from "../GeometrySelectionTools/styled";

export const PresentationToolsContainer = styled(GeometrySelectionWrapper)<{ isSharedPresentation?: boolean }>`
  ${({ isSharedPresentation }) =>
    !isSharedPresentation &&
    css`
      ${CollapsableContainer} {
        padding-left: 0;
        padding-right: 0;
      }
    `}
`;
